import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { loadTrackInfos } from '../../redux/modules/trackInfo/trackInfoCreators';
import GeoJsonMapLayer from './geoJsonMapLayer';
import { IRootState } from '../../redux/state';

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      loadTrackInfos,
    },
    dispatch
  );
}

function mapStateToProps(state: IRootState) {
  return {
    routes: state.genericMapRoutes.genericMapRoutes,
    agreements: state.genericMapRoutes.displayedGenericMapAgreements,
    genericMapLayers: state.genericMapRoutes.genericMapLayers,
    isAgreementsVisible: state.genericMapRoutes.isAgreementsVisible,
    bins: state.genericMapRoutes.displayedGenericMapAgreementLines,
    places: state.genericMapRoutes.displayedGenericMapPlaces,
    highlightedMarkers: state.genericMapRoutes.highlightedMarkers,
    selectedRouteIds: state.genericMapRoutes.routeIds,
    filterType: state.genericMapRoutes.filterType,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GeoJsonMapLayer);
